/**
 * Pet category and sub-type utilities for the WeTree Web UI
 *
 * Category replaces species; subType replaces breed (free text).
 * Sub-type label varies by category: Breed (dog/cat), Variety (aquatic), Morph (reptile/amphibian), Type (others).
 */

export { PET_SUBTYPE_LABEL, getPetSubtypeLabel } from '@/i18n/labelMaps';

export type PetCategoryType =
  | 'dog'
  | 'cat'
  | 'mammal'
  | 'equine'
  | 'bird'
  | 'aquatic'
  | 'reptile'
  | 'amphibian'
  | 'invertebrate'
  | 'exotic'
  | 'other';

export const PET_CATEGORY_VALUES: readonly PetCategoryType[] = [
  'dog',
  'cat',
  'mammal',
  'equine',
  'bird',
  'aquatic',
  'reptile',
  'amphibian',
  'invertebrate',
  'exotic',
  'other'
];

export const DEFAULT_PET_CATEGORY: PetCategoryType = 'other';
